import React from 'react';
import { StripBannerItem } from '@contracts';
import styled from 'styled-components';
import { MEDIA } from '@constants';
import { GatsbyImage } from 'gatsby-plugin-image';
import { TextVariant, Typography } from './Typography';

interface StripBannerItemsProps {
  items: StripBannerItem[];
}

const StripBannerItems: React.FC<StripBannerItemsProps> = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <BannerContent>
      {items.map((item, index) => (
        <Item key={index}>
          {item.image?.gatsbyImageData && (
            <ImageWrap>
              <GatsbyImage image={item.image?.gatsbyImageData ?? null} alt={item.image?.alt ?? ''} />
            </ImageWrap>
          )}
          <Typography $variant={TextVariant.UpperText5}>{item.title1?.text}</Typography>
        </Item>
      ))}
    </BannerContent>
  );
};

export default StripBannerItems;

const BannerContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 72px;
  white-space: nowrap;
  flex-shrink: 0;

  ${MEDIA.tablet} {
    gap: 16px;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
`;

const ImageWrap = styled.div`
  width: 32px;
  height: 32px;

  ${MEDIA.tablet} {
    width: 20px;
    height: 20px;
  }
`;
